<template>
  <div>
    <a-row v-if="!loading && !cards?.length" class="empty-row">
      <a-col :span="24">
        <a-empty description="该筛选条件下暂无商户数据"/>
      </a-col>
    </a-row>

    <a-row v-else :gutter="16" class="card-grid">
      <a-col
          v-for="card in cards"
          :key="card.merchantNo"
          :span="8"
      >
        <MerchantCard
            :card="card"
            @view-flow="$emit('view-flow', $event)"
        />
      </a-col>
    </a-row>

    <!-- 分页 -->
    <a-pagination
        v-if="pagination?.total > 0"
        :current="pagination.current"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-size-options="['12', '24', '36']"
        show-size-changer
        show-quick-jumper
        style="margin-top: 16px; text-align: right;"
        @change="onPageChange"
        @showSizeChange="onPageSizeChange"
    />
  </div>
</template>

<script>
import MerchantCard from './MerchantCard.vue';

export default {
  name: 'MerchantCardGrid',
  components: {MerchantCard},
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: () => ({current: 1, pageSize: 12, total: 0}),
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit('page-change', page);
    },
    onPageSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize;
      this.$emit('page-change', 1);
    },
  },
};
</script>

<style lang="less" scoped>
.card-grid {
  margin-top: 8px;
}

.empty-row {
  margin-top: 32px;
}
</style>